import { useErrorHandling } from 'ra-core'
import { useEffect, useState } from 'react'
import { http } from '../services/http'
import { StandData } from './expoStand'
import { ExpoStandProps } from './OrgPageRenderer'

export const useLoadExpoStand = ({ slug, locale = '', iso2 = '' }: ExpoStandProps) => {
  const errorHandling = useErrorHandling()
  const [standData, setStandData] = useState<StandData | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!slug) return
    setIsLoading(true)
    let queryString = ''
    if (locale || iso2) {
      let defaultParams: { locale?: string; iso2?: string } = {}
      if (locale) defaultParams.locale = locale
      if (iso2) defaultParams.iso2 = iso2
      const params = new URLSearchParams(defaultParams)
      queryString = params ? `?${params.toString()}` : ''
    }
    const url = `/partners/partner_expo_stand/${slug}/${queryString}`

    http.os
      .get(url)
      .then((res) => {
        if (res?.data) {
          setStandData(res?.data)
        }
      })
      .catch((err) => {
        errorHandling.data_provider(err, { msg: 'Failed to retrieve expo stand' })
        setStandData(null)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [slug, locale, iso2])

  return { standData, isLoading }
}
